<template>
    <div>
        <vue-headful :title="$t('specialist_card_title')" />
        <vs-card>
            <div
                :class="wMobile ? 'flex-col items-center' : 'items-start'"
                class="flex justify-between"
            >
                <div
                    class="flex"
                    :class="wMobile ? 'flex-col items-center' : ''"
                >
                    <!-- Аватар -->
                    <img
                        style="width: 180px"
                        :onerror="`this.src='${require('@/assets/images/not-photo.png')}'`"
                        :src="info.user_profile.avatar"
                        alt=""
                    />
                    <!-- ФИО -->
                    <div :class="wMobile ? 'text-center' : 'ml-8'" class="mt-4">
                        <h1>
                           
                            {{
                                info.user_profile.fullname
                            }}
                            {{
                                info.user_profile["last_name_" + $i18n.locale] === null || 
                                info.user_profile["last_name_" + $i18n.locale] === "" ?
                                 info.user_profile["last_name_ru"] : 
                                  info.user_profile["last_name_" + $i18n.locale]
                            }}
                            {{
                                info.user_profile["first_name_" + $i18n.locale] === null ||
                                info.user_profile["first_name_" + $i18n.locale] === "" ?
                                 info.user_profile["first_name_ru"] : 
                                  info.user_profile["first_name_" + $i18n.locale]
                            }}
                            {{
                                info.user_profile["middle_name_" + $i18n.locale] === null ||
                                info.user_profile["middle_name_" + $i18n.locale] === "" ?
                                 info.user_profile["middle_name_ru"] : 
                                  info.user_profile["middle_name_" + $i18n.locale]
                            }}
                        </h1>
                        <!-- Заголовок -->
                        <p v-if="!isEdit" class="text-xl font-medium">
                            {{ info["subtitle_" + $i18n.locale] }}
                        </p>

                        <!-- Выбор специалиста если юсер имеет несклолько ролей -->
                        <div class="mt-4" v-if="$route.query.specialist">
                            <h6>{{ $t("specialization") }}</h6>
                            <multiselect
                                class="mt-2"
                                v-model="typeSpec"
                                :options="specOptions"
                                :placeholder="$t('specialization')"
                                deselectLabel=""
                                selectLabel=""
                                value="uid"
                                label="name"
                                @input="selectType"
                            ></multiselect>
                        </div>

                        <!-- Язык перевода -->
                        <div class="mt-4" v-if="isEdit">
                            <h6>{{ $t("lang_translate") }}</h6>
                            <multiselect
                                class="mt-2"
                                v-model="langSelect"
                                :options="itemsLocale"
                                :placeholder="$t('lang_translate')"
                                value="value"
                                deselectLabel=""
                                selectLabel=""
                                order-by="value"
                                label="name"
                                @input="changeLocale"
                            ></multiselect>
                        </div>
                    </div>
                </div>

                <!-- Кнопка Редактировать информацию -->
                <vs-button
                    v-if="!isEdit && $route.query.specialist"
                    @click="isEdit = true"
                    class="mt-4"
                    icon="edit"
                    >{{ $t("edit") }}</vs-button
                >

                <!-- Кнопка Записаться на прием -->
                <vs-button
                    @click="dialog = true"
                    class="mt-4"
                    v-if="$route.query.uid !== undefined"
                    >{{ $t("make_appointment") }}</vs-button
                >
            </div>
            <!-- РЕДАКТИРОВАНИЕ -->

            <!-- Заголовок -->
            <div class="mt-4" v-if="isEdit">
                <h6>{{ $t("title") }}</h6>
                <vs-input
                    class="w-full mt-2"
                    v-model="data['subtitle_' + langLocale]"
                    :placeholder="$t('title')"
                ></vs-input>
            </div>

            <div class="mt-6">
                <!-- Время приема -->
                <h3>{{ $t("time_appointment") }}</h3>
                <div
                    class="mt-4"
                    v-if="!isEdit"
                    v-html="info['reception_room_' + $i18n.locale]"
                ></div>
                <div class="mt-4" v-else>
                    <quill-editor
                        v-model="data['reception_room_' + langLocale]"
                    ></quill-editor>
                </div>
            </div>

            <!-- Опсиание -->
            <div class="mt-4">
                <h3>{{ $t("description") }}</h3>
                <div
                    class="mt-4"
                    v-if="!isEdit"
                    v-html="info['description_' + $i18n.locale]"
                ></div>
                <div class="mt-4" v-else>
                    <quill-editor
                        v-model="data['description_' + langLocale]"
                    ></quill-editor>
                </div>
            </div>

            <!-- Сохранить изменения -->
            <vs-button
                @click="setNewData"
                id="button-load-more-posts"
                icon="save"
                class="vs-con-loading__container mt-6"
                v-if="isEdit"
                >{{ $t("save") }}</vs-button
            >
        </vs-card>
        <!-- Изменение время приема -->
        <ModalEdit
            v-if="$route.query.specialist"
            :specialist="$route.query.uid"
            v-model="dialogEdit"
        />
        <!-- Записаться  на прием -->
        <ModalWrite :specialist="$route.query.uid" v-model="dialog" />
    </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import ModalEdit from "./ModalEdit";
import ModalWrite from "./ModalWrite";
export default {
    components: {
        quillEditor,
        ModalEdit,
        ModalWrite,
    },
    props: {
        openM: {
            default: false,
            type: Boolean,
        },
    },
    computed: {
        wMobile() {
            return window.innerWidth < 800;
        },
    },
    data() {
        return {
            info: {
                user_profile: {
                    firstName: "",
                    lastName: "",
                    middleName: "",
                },

                subtitle: "",
            },
            data: {},
            langSelect: { name: this.$t("russian"), value: "ru" },
            langLocale: "ru",
            itemsLocale: [
                { name: this.$t("russian"), value: "ru" },
                { name: this.$t("kazak"), value: "kk" },
                { name: this.$t("english"), value: "en" },
            ],
            eData: [],
            specOptions: [],
            typeSpec: "",
            isEdit: false,
            dialog: false,
            time: "",
            dialogEdit: false,

            configdateTimePicker: {
                enableTime: true,
                enableSeconds: true,
                noCalendar: true,
            },
        };
    },

    async created() {
        this.$vs.loading();
        // Если заходит сепециалист
        if (this.$route.query.specialist) {
            const res = await this.$http(`specialists/about-me/`);
            this.info = res.data[0];
            this.eData = res.data;
            this.specOptions = res.data.map((item) => {
                return item.specialist_type;
            });
            this.typeSpec = res.data[0].specialist_type;
            this.data = this.info;

            // Если uid не найден
        } else if (this.$route.query.uid !== undefined) {
            const res = await this.$http(
                `specialists/specialist-cv/${ this.$route.query.uid }/`
            );
            this.info = res.data;
            if (this.openM) {
                this.dialog = true;
            }
        } else {
            this.$router.push({ name: "cabinet-specialist-see" });
        }
        this.$vs.loading.close();
    },
    methods: {
        changeLocale() {
            this.langLocale = this.langSelect.value;
        },
        // Выбор если несколько специалистов
        selectType() {
            let d = this.eData.filter(
                (item) => item.specialist_type.uid === this.typeSpec.uid
            );
            this.info = d[0];
            this.data = d[0];
        },
        // Кнопка сохранить мзменения
        async setNewData() {
            this.$vs.loading({
                background: this.backgroundLoading,
                color: this.colorLoading,
                container: "#button-load-more-posts",
                scale: 0.45,
            });

            try {
                delete this.data["description"];
                delete this.data["reception_room"];
                const res = await this.$http.put(
                    `specialists/about-me/${ this.info.uid }/`,
                    this.data
                );
                if (res.status === 200) {
                    this.$vs.notify({
                        title: this.$t("succesful"),
                        color: "primary",
                    });
                    this.info = res.data;
                    this.isEdit = false;
                }
            } catch (e) {
                this.$vs.notify({
                    title: this.$t("error"),
                    color: "danger",
                });
            }
            this.langSelect = { name: this.$t("russian"), value: "ru" };
            this.$vs.loading.close("#button-load-more-posts > .con-vs-loading");
        },
    },
};
</script>

<style></style>
